import { PATIENT_DASHBOARD_UPDATE } from "../actions/type";

const INITIAL_STATE = {
  preExistingConditions: {
    anemia: {
      condition: "",
      self: "",
      family: "",
    },
    asthma: {
      condition: "",
      self: "",
      family: "",
    },
    diabetes: {
      condition: "",
      self: "",
      family: "",
    },
    cholesterol: {
      condition: "",
      self: "",
      family: "",
    },
    thyroidDisease: {
      condition: "",
      self: "",
      family: "",
    },
    heartDisease: {
      condition: "",
      self: "",
      family: "",
    },
    stroke: {
      condition: "",
      self: "",
      family: "",
    },
    glaucoma: {
      condition: "",
      self: "",
      family: "",
    },
    highBloodPressure: {
      condition: "",
      self: "",
      family: "",
    },
    cancer: {
      condition: "",
      self: "",
      family: "",
    },
    tuberculosis: {
      condition: "",
      self: "",
      family: "",
    },
    allergies: {
      condition: "",
      self: "",
      family: "",
    },
  },
  lifestyles: {
    alcohol: "",
    smoke: "",
    exercise: "",
    sleep: "",
    travel: ""
  },
  medications: [],
  allergies: [],
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case PATIENT_DASHBOARD_UPDATE:
      return {
        ...state,
        [payload.name]: payload.value,
      };
    default:
      return state;
  }
};
